import { useEffect, useState } from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener('change', onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isMobile
}

// Tailwind's `sm` breakpoint. Layouts that switch at `sm:` (the web top bar)
// use this instead of useIsMobile, whose 768px threshold would leave a
// 640-767px band where the JS and CSS layouts disagree.
const NARROW_BREAKPOINT = 640

export function useIsNarrow() {
  const [isNarrow, setIsNarrow] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${NARROW_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsNarrow(window.innerWidth < NARROW_BREAKPOINT)
    }
    mql.addEventListener('change', onChange)
    setIsNarrow(window.innerWidth < NARROW_BREAKPOINT)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isNarrow
}
